"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserPostMessageBodyToJSON = exports.UserPostMessageBodyFromJSONTyped = exports.UserPostMessageBodyFromJSON = void 0;
function UserPostMessageBodyFromJSON(json) {
    return UserPostMessageBodyFromJSONTyped(json, false);
}
exports.UserPostMessageBodyFromJSON = UserPostMessageBodyFromJSON;
function UserPostMessageBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tournamentID': json['tournamentID'],
        'message': json['message'],
    };
}
exports.UserPostMessageBodyFromJSONTyped = UserPostMessageBodyFromJSONTyped;
function UserPostMessageBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tournamentID': value.tournamentID,
        'message': value.message,
    };
}
exports.UserPostMessageBodyToJSON = UserPostMessageBodyToJSON;
